// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './components/App';
import Router from './router';
import store from './store';
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import VModal from 'vue-js-modal';
import Auth from './plugins/auth.js';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueClipboard from 'vue-clipboard2';
import VTooltip from 'v-tooltip';
import Toasted from 'vue-toasted';
import VueGtm from 'vue-gtm';
import VueAnalytics from 'vue-analytics';
import IdleVue from 'idle-vue'

Vue.config.productionTip = false;

// register plugins here
Vue.use(VueResource);
Vue.use(Auth);
Vue.use(VModal);
Vue.use(VeeValidate, {inject: false});
Vue.use(VueYouTubeEmbed);
Vue.use(VueClipboard);
Vue.use(VTooltip);
Vue.use(Toasted, {duration: 2000});
Vue.use(VueGtm);
Vue.use(VueAnalytics, {
  id: 'UA-33584413-1',
})
const eventsHub = new Vue()
// Idle time is 11 hours 59 minutes 42550000
Vue.use(IdleVue, {idleTime: 42550000, eventEmitter: eventsHub})

// interceptors
Vue.http.interceptors.push(function (request, next) {
  const tailUrl = request.url;
  request.url = `${process.env.BASE_URL}${request.url}`;
  const token = Vue.auth.getToken();
  if (token) {
    request.headers.set('x-access-token', token);
  }
  // on stage one we have the equifax modal
  if (tailUrl !== 'broker/manage-application/2') {
    // toggle active request
    store.commit('activeRequest');
  }

  next(function (response) {
    if (response.status === 403) {
      // invalid token.
      Vue.auth.destroyToken();
      location.reload();
    }
    // toggle active request
    // we listen to this state change in App.vue l:24
    if (tailUrl !== 'broker/manage-application/2') {
      // toggle active request
      store.commit('activeRequest');
    }
    // modify the response write here
    if (response.status === 422) {
      response.body.errors.forEach(function (e) {
      });
    }
  });
});

// configure route guards

Router.beforeEach(function (to, from, next) {
  let type = false;
  if (to.matched[0].meta.userType) {
    type = to.matched[0].meta.userType;
  }

  // prevent access to routes with requiresGuest
  if (
    to.matched.some(function (record) {
      return record.meta.requiresGuest;
    }) &&
    Vue.auth.loggedIn(type)
  ) {
    let redirectUrl = '/';
    if (to.matched[0].meta.fallbackUrl) {
      redirectUrl = to.matched[0].meta.fallbackUrl;
    }

    next({
      path: redirectUrl,
    });
  } else if (
    to.matched.some(function (record) {
      return record.meta.requiresAuth;
    }) &&
    !Vue.auth.loggedIn(type)
  ) {
    let redirectUrl = '/';
    if (to.matched[0].meta.fallbackUrl) {
      redirectUrl = to.matched[0].meta.fallbackUrl;
    }
    next({
      path: redirectUrl,
      query: {redirect: to.fullPath},
    });
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: Router,
  store,
  components: {App},
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js